import React from 'react';
import Button from '@mui/material/Button';
import { Grid, Paper } from '@mui/material';
import { Form, Formik } from 'formik';
import InputForm from '../../commun/input-form';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { DocumentsFormDto } from '../../../services/dtos/documents.dto';
import '../filter-form.scss';

/**
 * Compsant qui permet de rechercher les compositions
 * @constructor
 * @param props
 */
export default function DocumentsForm(
    props: Readonly<{
        handlerSearch: (e: DocumentsFormDto) => void;
        searching: boolean;
        hideTypeField?: boolean;
    }>
) {
    //Initialisation des valeurs
    const iniValues: DocumentsFormDto = {
        name: '',
    };

    return (
        //Retourne la vue
        <Formik
            initialValues={iniValues}
            onReset={props.handlerSearch}
            onSubmit={props.handlerSearch}
            className="form-composition"
        >
            {/* Formulaire */}
            <Form>
                <Paper className="filter-form" elevation={0}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={9}>
                            <InputForm id="name" name="name" label="Nom" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <div className="filter-form__actions">
                                <Button
                                    variant="outlined"
                                    type="reset"
                                    className="filter-form__button filter-form__button--reset"
                                    startIcon={<ClearIcon />}
                                >
                                    Annuler
                                </Button>
                                <Button
                                    data-testid={'search-documents'}
                                    type="submit"
                                    variant="contained"
                                    className="filter-form__button"
                                    startIcon={<SearchIcon />}
                                    disabled={props.searching}
                                >
                                    {props.searching ? 'Recherche...' : 'Rechercher'}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </Form>
        </Formik>
    );
}
